/*
    locale.js
    Language Configuration for NPO Reina Website
    サンタナム リシ
*/

// Current language setting - change this to 'en' for English version
export const CURRENT_LOCALE = 'ja';

// Stripe locale mapping
export const STRIPE_LOCALE = {
    'ja': 'ja',
    'en': 'en'
};

// Language labels for UI (when you add language switcher)
export const LANGUAGE_LABELS = {
    'ja': '日本語',
    'en': 'English'
};

// Get current Stripe locale
export const getStripeLocale = () => STRIPE_LOCALE[CURRENT_LOCALE] || 'ja';

// Get current language label
export const getCurrentLanguageLabel = () => LANGUAGE_LABELS[CURRENT_LOCALE] || '日本語';

// Check if current locale is Japanese
export const isJapanese = () => CURRENT_LOCALE === 'ja';

// Check if current locale is English  
export const isEnglish = () => CURRENT_LOCALE === 'en';
